const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
async function request(path, options = {}) {
  const token = localStorage.getItem('jwt');
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const url = `${API_BASE_URL}${path}`;
  // Log outgoing request for debugging (shows in Console; Network will show actual fetch)
  console.debug('API request →', options.method || 'GET', url, { headers, body: options.body ? options.body : undefined });

  let response;
  try {
    response = await fetch(url, {
      headers,
      ...options,
    });
  } catch (fetchErr) {
    console.error('Network error during API request', { url, err: fetchErr });
    const err = new Error('Network error: ' + (fetchErr.message || String(fetchErr)));
    err.original = fetchErr;
    throw err;
  }

  // try to parse json, but tolerate non-json responses
  let payload = {};
  try {
    payload = await response.json();
  } catch (e) {
    // ignore
  }

  if (!response.ok) {
    const msg = (payload && payload.message) || response.statusText || 'Request failed';
    console.error('API error response', { url, status: response.status, payload });
    const err = new Error(msg);
    err.status = response.status;
    err.payload = payload;
    throw err;
  }

  return payload;
}

export async function healthCheck() {
  return request('/health');
}

export async function saveCalculation(payload) {
  return request('/calculations', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function addRoleProfile(payload) {
  return request('/master/role-profiles', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function saveProposal(payload) {
  return request('/proposals', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function saveAdvisorRequest(payload) {
  return request('/advisor', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function authRegister(payload) {
  return request('/auth/register', {
    method: 'POST',
    body: JSON.stringify({ ...payload, channel: payload.channel || 'whatsapp' }),
  });
}

export async function authLogin(payload) {
  return request('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ ...payload, channel: payload.channel || 'whatsapp' }),
  });
}

export async function authVerify(payload) {
  return request('/auth/verify', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function authForgotPassword(payload) {
  return request('/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function authResetPassword(payload) {
  return request('/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function authStartVerify(payload) {
  return request('/auth/verify/start', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function authCheckVerify(payload) {
  return request('/auth/verify/check', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function saveFormData(payload) {
  return request('/auth/form', {
    method: 'POST',
    body: JSON.stringify({ formData: payload }),
  });
}

export async function fetchFormData() {
  return request('/auth/form');
}

export async function fetchMaster() {
  return request('/master/role-types');
}

export async function fetchRates() {
  return request('/master/rates');
}

export function setAuthToken(token) {
  if (token) localStorage.setItem('jwt', token);
  else localStorage.removeItem('jwt');

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('auth:changed'));
  }
}
